import pluginsPanel from './pluginsPanel';
import slotSelectionExtendedPanel from './slotSelectionExtendedPanel';

export { pluginsPanel, slotSelectionExtendedPanel };
